import * as React from 'react';
import styled from 'styled-components'
import {ConstBreakPoint, ConstCalc, ConstHeight, ConstWidth} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
}

const PageWrapperDefault: React.FC<IProps> = (props) => {

    const { ...DivProps } = props;

    return (<div {...DivProps} />)

};

const PageWrapper = styled(PageWrapperDefault)`
    position: relative;
    box-sizing: content-box;
    min-height: ${ConstCalc.PageWrapperMinHeightSp}; // headerの高さ + PageWrapperの上下のpadding 
    margin: 0 auto;
    padding: ${ConstHeight.PagePaddingTopSp} ${ConstWidth.PagePaddingRightSp} ${ConstHeight.PagePaddingBottomSp} ${ConstWidth.PagePaddingLeftSp};
    max-width: ${ConstWidth.ContentsMaxWidth};
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        min-height: ${ConstCalc.PageWrapperMinHeight};
        padding-top: ${ConstHeight.PagePaddingTop}
        padding-left: ${ConstWidth.PagePaddingLeftTablet};
        padding-right: ${ConstWidth.PagePaddingRightTablet};
        padding-bottom: ${ConstHeight.PagePaddingBottom};
    }
    @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
        padding-left: ${ConstWidth.PagePaddingLeftPc};
        padding-right: ${ConstWidth.PagePaddingRightPc};
    }
`;

export default PageWrapper;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/wrapper/page_wrapper.tsx